<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                The link you have used has expired
              </strong>
            </p>
          </div>
        </div>
        <div class="row medium-font">
          <div class="col text-center">
            <p>
              <strong>
                Enter the email you used to register to request a new link.
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background text-center">
        <form @submit.prevent="sendCode" @keydown="clearError($event)" autocomplete="no">
          <div class="form-row">
            <div class="col">
              <input
                v-model="email"
                id="email"
                type="text"
                class="form-control login-input"
                placeholder="Email"
              />
              <error-field :errors="errors" field="email" />
            </div>
          </div>
          <input type="submit" class="btn btn-primary form-control login-button"
                 value="Resend email"
                 :disabled="errors.any()"
          />
        </form>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  name: 'VerificationExpired',
  components: {
    ErrorField,
  },
  data: () => ({
    email: '',
    errors: new Errors(),
  }),
  methods: {
    sendCode() {
      axios
        .post('resend-email', { email: this.email })
        .then(() => {
          this.$router.push('/verification-resent');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/VerificationExpired.vue